import styled from "styled-components";

export const CardStyle = styled.div`
  box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
  transition: box-shadow 0.3s ease;
  border-radius: 8px;
  border: 1px solid white;
  padding: 1vh 1.5vh;
  display: flex;
  flex-direction: column;
  min-width: 30vh;
  height: 10vh;
  margin-bottom: 5vh;
  overflow-wrap: anywhere;
  margin-right: 8vh;
  justify-content: space-between;
  font-family: thin-pro, sans-serif;
  :hover {
    box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
  }

  @media screen and (max-height: 900px) {
    height: 12vh;
  }
`;

export const Card2Style = styled.div`
  .card-container {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 1vh 1.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    min-width: 30vh;
    height: 10vh;
    margin-bottom: 5vh;
    overflow-wrap: anywhere;
    font-family: medium-pro, sans-serif;
    margin-right: 8vh;
    justify-content: space-between;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }

  .config-heading {
    font-size: 1.4rem;
  }

  .arrow-style {
    font-size: 25px;
    :hover {
      color: #f28809;
    }
  }
  .heading {
    font-size: 1.5vh;
    align-self: center;
    color: #5e5d5c;
  }
  .total {
    font-size: 2vh;
    font-weight: 400;
    align-self: center;
  }

  .total-sm {
    font-size: 1.5vh;
    font-weight: 400;
    align-self: center;
  }

  /* For large devices */
  @media screen and (max-width: 1024px) {
    .card-container {
      height: 12vh;
    }
    .heading {
    }
    .total {
    }
    .total-sm {
    }
  }

  /* For medium devices */
  @media screen and (max-width: 576px) {
    .card-container {
      margin-right: 0;
    }
  }
  @media screen and (max-height: 900px) {
    .card-container {
      height: 12vh;
    }
  }
`;
